import React from 'react'
import styled, { keyframes } from 'styled-components'
import { menu } from '../listas/menu'

const Full = ({ activo, cambio }) => {
    return (
        <Container activo={activo.toString()}>
            <Lista>
                {menu.map((element) => {
                    return <Elemento key={element.titulo} >
                        <a href={element.link}>
                            <span>{element.titulo}</span>
                        </a>
                    </Elemento>

                })}
                <Elemento onClick={() => cambio(false)}>
                    <span>X</span>
                </Elemento>
            </Lista>
        </Container>
    )
}



const Container = styled.nav`
    transition: 1s ease all;
    height: 100vh;
    width: 100vw;
    padding:15px;
    position: fixed;
    z-index: 5;
    transform: translateY(${props => props.activo === 'true' ? '42%' : '-100%'});
    background-color: white;
`

const Lista = styled.ul`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;

`
const Elemento = styled.li`
    height: 100%;
    width:100%;
    border-bottom: 1px solid black;
    display: flex;
    justify-content: center;
    align-items: center;

`

export default Full